import VisibilityTracker from './visibility-tracker';
import AnalyticsTracker from './analytics-tracker';

const analyticsTracker  = new AnalyticsTracker();
const visibilityTracker = new VisibilityTracker();

visibilityTracker.onImpression = (impressions) => {
	analyticsTracker.trackEvents(impressions);
};

function getParsedAttributes(event) {
	const target     = event.currentTarget;
	const attributes = target.dataset.attributes;

	if (!attributes) {
		return;
	}

	return JSON.parse(attributes);
}

function trackAnalytics(event) {
	const attributes = getParsedAttributes(event);

	analyticsTracker.trackEvent(attributes);
}

function initTrackAnalytics() {
	document.querySelectorAll('.js-analytics-click')
			.forEach((element) => {
					// click only: on touch a tap fires touchend AND a synthetic click,
					// so binding both double-counts the event (touchend also misfires
					// at the end of a scroll swipe). click is suppressed on scroll.
					element.removeEventListener('click', trackAnalytics);
					element.addEventListener('click', trackAnalytics);
				},
			);
}

document.addEventListener('DOMContentLoaded', function() {
	document.querySelectorAll('.js-profile-visit')
			.forEach((element) => {
				analyticsTracker.trackEvent(JSON.parse(element.dataset.attributes));
			});

	document.querySelectorAll('.js-profile-impressions')
			.forEach((element) => {
				visibilityTracker.observe(element);
			});

	initTrackAnalytics();

	document.addEventListener('splideSlideChange', function(event) {
		analyticsTracker.trackEvent(event.detail);
	});

	document.addEventListener('lightboxSlideChange', function(event) {
		analyticsTracker.trackEvent(event.detail);
	});
});

document.addEventListener('analytics:refresh', initTrackAnalytics);
